import type { SVGProps } from 'react';
const SvgWaterfallChart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#waterfall_chart_svg__a)">
      <path
        fill="currentColor"
        d="M18 4h3v16h-3V4ZM3 13h3v7H3v-7Zm11-9h3v3h-3V4Zm-4 1h3v4h-3V5Zm-3 5h3v4H7v-4Z"
      />
    </g>
    <defs>
      <clipPath id="waterfall_chart_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWaterfallChart;
